import { render, staticRenderFns } from "./ActionRequiredUsersModal.vue?vue&type=template&id=70943c1f&scoped=true"
import script from "./ActionRequiredUsersModal.vue?vue&type=script&lang=ts"
export * from "./ActionRequiredUsersModal.vue?vue&type=script&lang=ts"
import style0 from "./ActionRequiredUsersModal.vue?vue&type=style&index=0&id=70943c1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70943c1f",
  null
  
)

export default component.exports